import React from 'react';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/ErrorMessage';
import LoadingState from '../../components/LoadingState';
import { useTraining } from './hooks/useTraining';
import CourseContents from './components/CourseContents';
import TrainingHeader from './components/TrainingHeader';
import { Container, ContainerFluid } from '../../components/Layout';
import { Color, Shadow } from '../../app/StyleGuide';
import styled from 'styled-components';
import Breadcrumbs from '../../components/Breadcrumbs';
import compilationService from '../../services/compilationService';
import { useTrainingAccess } from './hooks/useTrainingAccess';

const TrainingContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: calc(100vh - 60px); // 60px (header)
`;

const CompilationBanner = styled.div`
  background: ${Color.Gray._50};
  box-shadow: ${Shadow.small};
`;

const BannerImg = styled.img`
  width: 100%;
  object-fit: cover;
  margin: 0;
`;

export function Training() {
  const { trainingId, compilationId } = useParams<{ trainingId: string; compilationId?: string }>();
  const { data, compilation, nextAction } = useTraining(trainingId, compilationId);
  const userAccess = useTrainingAccess(data.training);

  const crumbs = [
    window.location.href.includes('catalog')
      ? { name: 'Catalog', route: '#/catalog' }
      : { name: 'Search Results', route: '#/search' },
    ...(window.location.href.includes('compilation') && compilation
      ? [{ name: compilation.name, route: `#/catalog/compilation/${compilation._id}` }]
      : []),
    { name: data?.training?.name },
  ];

  return (
    <ContainerFluid>
      {data.isLoading ? (
        <LoadingState />
      ) : data.error || !data.training ? (
        <Container>
          <ErrorMessage />
        </Container>
      ) : (
        <TrainingContainer>
          <Breadcrumbs crumbs={crumbs} />
          {compilation && (
            <ContainerFluid>
              {compilation.image && (
                <CompilationBanner>
                  <BannerImg
                    src={compilationService.getCompilationImageUrl(compilation.image)}
                    alt={compilation.name}
                  />
                </CompilationBanner>
              )}
            </ContainerFluid>
          )}
          <TrainingHeader training={data.training} nextAction={nextAction} userAccess={userAccess} />
          <CourseContents training={data.training} nextAction={nextAction} userAccess={userAccess} />
        </TrainingContainer>
      )}
    </ContainerFluid>
  );
}
